import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';

import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { ConditionSetting, ConditionTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { Condition, Operator, TableOption } from '../../components/kiene-table/table-option';

import { MaterialService } from '../../warehouse/material/material.service';
import { Supplier } from '../../warehouse/supplier/supplier';
import { SupplierService } from '../../warehouse/supplier/supplier.service';
import { WarenkorbPosition } from '../warenkorb/warenkorb';
import { WarenkorbService } from '../warenkorb/warenkorb.service';
import { Bestellvorschlag } from './bestellvorschlag';
import { ChangeBestellmengenDialogComponent } from './change-bestellmengen-dialog/change-bestellmengen-dialog.component';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-bestellvorschlaege',
    templateUrl: './bestellvorschlaege.component.html',
    styleUrls: ['./bestellvorschlaege.component.scss'],
})
export class BestellvorschlaegeComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
        private tableService: KieneTableService,
        private warenkorbService: WarenkorbService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Bestellvorschläge';
        this.tableDescriptor.uniqueIdentifier = 'Bestellvorschläge';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'bestellvorschlag/';
        this.tableDescriptor.route = '/lager/artikel/';
        this.tableDescriptor.nameOfIdField = 'artikel_id';
        this.tableDescriptor.searchPlaceholder = 'Bestellvorschläge durchsuchen';

        this.tableDescriptor.columns.push(new TableColumn('artikel_id', 'Artikel ID'));
        this.tableDescriptor.columns.push(new TableColumn('bezeichnung', 'Artikel'));
        this.tableDescriptor.columns.push(new TableColumn('einheit', 'Einheit'));

        const conditionSettings = [
            new ConditionSetting([new Condition('status', Operator.GLEICH, 1)], {
                icon: 'lens',
                color: 'green',
                tooltip: 'Bestand ausreichend vorhanden',
            }),
            new ConditionSetting([new Condition('status', Operator.GLEICH, 2)], {
                icon: 'warning',
                color: 'orange',
                tooltip: 'Mindestbestand bald erreicht',
            }),
            new ConditionSetting([new Condition('status', Operator.GLEICH, 3)], {
                icon: 'error',
                color: 'red',
                tooltip: 'Mindestbestand erreicht oder unterschritten',
            }),
        ];
        this.tableDescriptor.columns.push(
            new ConditionTableColumn('status', 'Status', conditionSettings, { sortFields: ['status'] }),
        );

        this.tableDescriptor.columns.push(new TableColumn('apotheke', 'Menge Apotheke', 'number'));
        this.tableDescriptor.columns.push(new TableColumn('lager', 'Menge Lager', 'number'));
        this.tableDescriptor.columns.push(new TableColumn('gesamt', 'Menge Gesamt', 'number'));
        this.tableDescriptor.columns.push(new TableColumn('mindestbestand', 'Mindestbestand'));
        // this.tableDescriptor.columns.push(new TableColumn('fehlend', 'Fehlende Menge min.', 'number'));
        this.tableDescriptor.columns.push(new TableColumn('bestellmenge', 'Mindestbestellmenge'));
        this.tableDescriptor.columns.push(new TableColumn('bestellt', 'Bestellt'));
        this.tableDescriptor.columns.push(new TableColumn('warenkorb', 'Warenkorb'));

        this.tableDescriptor.permissionView = 1191;

        this.tableDescriptor.options.push(
            new TableOption(
                this.openAddToWarenkorbDialog.bind(this),
                'Zum Warenkorb hinzufügen',
                'add_shopping_cart',
                1772,
            ),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.openEditBestellmengenDialog.bind(this), 'Bestellmengen editieren', 'edit', 1770),
        );
        this.tableDescriptor.options.push(
            new TableOption(
                this.openRemoveBestellvorschlagDialog.bind(this),
                'Bestellvorschlag entfernen',
                'remove',
                1770,
            ),
        );

        this.tableDescriptor.initialSortColumn = 'status';
        this.tableDescriptor.initialSortDirection = 'desc';
    }

    openRemoveBestellvorschlagDialog(b: Bestellvorschlag) {
        const input = new ConfirmDialogInput();
        input.headline = 'Bestellvorschlag entfernen';
        input.text = 'Hiermit wird der Artikel ' + b.bezeichnung + ' nicht mehr in den Bestellvorschlägen angezeigt.';
        input.okButton = 'Entfernen';

        let dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '50%', minWidth: '300px', data: input });

        dialogRef.afterClosed().subscribe({
            next: (result: ConfirmDialogResult) => {
                if (result?.confirmed) {
                    b.bestellvorschlag = 0;
                    this.tableService
                        .updateGeneric(this.apiBaseUrl + 'bestellvorschlag/update_artikel.php', b)
                        .subscribe(
                            () => {
                                this.messageService.infoMessage('Der Bestellvorschlag wurde erfolgreich entfernt');
                                this.tableService.reload();
                            },
                            error => {
                                this.messageService.errorMessage(
                                    'Beim Entfernen des Bestellvorschlags ist ein Fehler aufgetreten.',
                                    error,
                                );
                            },
                        );
                }
            },
        });
    }

    openEditBestellmengenDialog(b: Bestellvorschlag) {
        let dialogRef = this.dialog.open(ChangeBestellmengenDialogComponent, {
            width: '50%',
            minWidth: '300px',
            data: { bestellvorschlag: b },
        });

        dialogRef.afterClosed().subscribe(() => {
            this.tableService.reload();
        });
    }

    openAddToWarenkorbDialog(b: Bestellvorschlag) {
        let dialogRef = this.dialog.open(AddArticleToWarenkorbDialog, {
            width: '50%',
            minWidth: '300px',
            data: { bestellvorschlag: b },
        });

        dialogRef.afterClosed().subscribe(result => {
            let wkp: WarenkorbPosition = result;
            this.warenkorbService.addWarenkorbPositionToWarenkorb(wkp).subscribe(
                () => {
                    this.warenkorbService.updateShoppingCartBadge();
                    this.messageService.infoMessage('Der Artikel wurde zum Warenkorb hinzugefügt!');
                    this.tableService.reload();
                },
                error => {
                    this.messageService.errorMessage('Fehler', error);
                },
            );
        });
    }
}

@Component({
    selector: 'add-article-to-warenkorb-dialog',
    template: `<h3 mat-dialog-title>Artikel dem Warenkorb hinzuf&uuml;gen</h3>
        <div mat-dialog-content>
            <h3>{{ bestellvorschlag.bezeichnung }}</h3>
            <p>Bitte geben Sie die Bestellmenge ein:</p>
            <mat-form-field>
                <input matInput type="number" placeholder="Bestellmenge" [(ngModel)]="bestellvorschlag.bestellmenge" />
            </mat-form-field>
            <div *ngIf="lieferanten.length > 1">
                <p>Bitte w&auml;hlen Sie den Lieferanten aus:</p>
                <mat-form-field style="width: 100%;">
                    <mat-select [(value)]="selectedLieferant">
                        <mat-option *ngFor="let l of lieferanten" [value]="l">{{ l.bezeichnung }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div mat-dialog-actions>
            <button mat-button color="primary" (click)="onCancelClick()">Abbrechen</button>
            <button mat-raised-button color="primary" (click)="addToWarenkorb()">Hinzuf&uuml;gen</button>
        </div>`,
})
export class AddArticleToWarenkorbDialog {
    bestellvorschlag: Bestellvorschlag;
    lieferanten: Supplier[] = [];
    selectedLieferant: Supplier = new Supplier();

    constructor(
        public dialogRef: MatDialogRef<AddArticleToWarenkorbDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private materialService: MaterialService,
        private supplierService: SupplierService,
    ) {
        this.bestellvorschlag = data.bestellvorschlag;
        this.loadSupplierForArticle(this.bestellvorschlag.artikel_id);
    }

    loadSupplierForArticle(articleId: number) {
        this.supplierService.getSuppliersForMaterialId(articleId).subscribe(
            response => {
                this.lieferanten = response.records;
                if (this.lieferanten.length === 1) {
                    this.selectedLieferant = this.lieferanten[0];
                }
            },
            () => {},
        );
    }

    addToWarenkorb() {
        const wkp: WarenkorbPosition = new WarenkorbPosition();
        wkp.artikel_id = this.bestellvorschlag.artikel_id;
        wkp.artikel = this.bestellvorschlag.bezeichnung;
        wkp.einheit = this.bestellvorschlag.einheit;
        wkp.lieferant_id = this.selectedLieferant.lieferant_id;
        wkp.menge_soll = this.bestellvorschlag.bestellmenge;
        this.dialogRef.close(wkp);
    }

    onCancelClick(): void {
        this.dialogRef.close(false);
    }
}
